var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "#5c9e31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 21,
    height: 38,
    fill: "#d22f27"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 36,
    r: 12,
    fill: "none",
    stroke: "#fcea2b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    x2: 26,
    y1: 24,
    y2: 48,
    fill: "none",
    stroke: "#fcea2b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#fcea2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "26 39.5 17 44 35 44 26 39.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#fcea2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "26 33.5 35 28 26.5 29.5 17 28 26 33.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#fcea2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "38 36 26 41 14 36 26 31 38 36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21,28H31a0,0,0,0,1,0,0V39a5,5,0,0,1-5,5h0a5,5,0,0,1-5-5V28A0,0,0,0,1,21,28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 28,
    width: 3,
    height: 16,
    fill: "#1e50a0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 30,
    width: 3,
    height: 10,
    transform: "translate(61 9) rotate(90)",
    fill: "#1e50a0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21,28H31a0,0,0,0,1,0,0V39a5,5,0,0,1-5,5h0a5,5,0,0,1-5-5V28A0,0,0,0,1,21,28Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.ebbaa856cec90d4d6372afeb35b5fbfb.svg";
export { ForwardRef as ReactComponent };